<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.stop="click">
        <div class="modal-container" @click.stop="none">
          <button class="modal-close-btn" @click="closeDialog">&times;</button>
          <div class="modal-body">
            <div class="title">Cambia icona del servizio</div>
            <v-tabs v-model="activeTab" slider-color="orange" show-arrows>
              <v-tab
                v-for="cat in categories"
                :key="cat"
                :href="'#tab-' + cat"
              >{{ cat }}</v-tab>
              <v-tabs-items v-model="activeTab" class="tabs-content">
                <v-tab-item
                  v-for="cat in categories"
                  :key="cat"
                  :id="'tab-' + cat"
                  :value="'tab-' + cat"
                >
                  <div class="tab-scroll">
                    <v-container class="grey lighten-5">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex
                            xs2 sm2 md1
                            v-for="(item, index) in imagesByCategory[cat]"
                            :key="index"
                          >
                            <v-card @click="loadImage(item)" class="iconMargin">
                              <v-img :src="item.path" />
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-container>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <my-upload
                ref="cropUpload"
                noCircle
                v-model="showCrop"
                :width="256"
                :height="256"
                :withCredentials="true"
                langType="it"
                @crop-success="onCropSuccess"
              ></my-upload>
              <v-btn
                class="q-orange-bk q-text-whitesmoke"
                :disabled="uploading"
                @click="showCrop = true"
              >
                <v-icon left>cloud_upload</v-icon>
                {{ uploading ? 'Caricamento...' : 'Carica immagine' }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn class="" @click="closeDialog"
                >Chiudi</v-btn
              >
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ajax from "../../ajax.js";
import ImageCompressor from "image-compressor.js";
import myUpload from "vue-image-crop-upload";

export default {
  name: "DialogImages",
  components: {
    "my-upload": myUpload
  },
  props: {
    images: {
      type: Array,
      default: function() {
        return [];
      }
    },
    shopId: {
      type: [Number, String],
      default: null
    },
    token: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      uploading: false,
      showCrop: false,
      activeTab: null
    };
  },
  computed: {
    imagesByCategory() {
      const map = {};
      (this.images || []).forEach(img => {
        const isCustom = img.path && img.path.includes('/images/shops/');
        const cat = isCustom ? "Caricate" : (img.category || "Altro");
        if (!map[cat]) map[cat] = [];
        map[cat].push(img);
      });
      // "Caricate" always first
      const ordered = {};
      if (map["Caricate"]) ordered["Caricate"] = map["Caricate"];
      Object.keys(map)
        .filter(k => k !== "Caricate")
        .sort()
        .forEach(k => (ordered[k] = map[k]));
      return ordered;
    },
    categories() {
      return Object.keys(this.imagesByCategory);
    }
  },
  methods: {
    click: function() {
      this.$emit("click");
    },
    none: function() {
      // serve per prevenire la chiusura del modale se clicco nel dialog
    },
    closeDialog: function() {
      this.$emit("close-dialog");
    },
    loadImage: function(item) {
      this.closeDialog();
      this.$emit("click-image", item);
    },
    onCropSuccess: async function(imgDataUrl) {
      if (!this.shopId || !this.token) return;
      this.uploading = true;
      try {
        // converti dataUrl in Blob
        const res = await fetch(imgDataUrl);
        const blob = await res.blob();
        const imageCompressor = new ImageCompressor();
        const compressed = await imageCompressor.compress(blob, {
          quality: 0.6,
          maxWidth: 256,
          maxHeight: 256
        });
        const data = new FormData();
        data.append("files", compressed, "service-icon.jpg");
        const response = await ajax.axios.post(
          ajax.baseUrl() + "/admin/shops/shop/" + this.shopId + "/services/images",
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + this.token
            },
            withCredentials: true
          }
        );
        this.$emit("image-uploaded", response.data.data.images[0]);
        // porta il tab attivo su "Caricate"
        this.activeTab = "#tab-Caricate";
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("Upload failed", e);
      } finally {
        this.uploading = false;
      }
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 20;
  padding: 5px;
}
.iconMargin {
  margin: 10px;
  padding: 5px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.modal-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  max-height: 95vh;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.modal-close-btn {
  position: absolute;
  top: 0;
  right: 12px;
  background: none;
  border: none;
  font-size: 36px;
  line-height: 1;
  cursor: pointer;
  color: #555;
  z-index: 1;
}

.modal-close-btn:hover {
  color: #000;
}

.modal-footer {
  flex-shrink: 0;
  padding: 8px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
}

.modal-default-button {
  float: right;
}

/*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (min-width: 720px) {
  .modal-wrapper {
    padding: 20px;
  }
  .modal-container {
    max-width: 1200px;
  }
}

/* Altezza fissa del contenuto tab */
.tabs-content {
  height: 500px;
}

.tab-scroll {
  height: 500px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/DialogImages.vue